import React, { useEffect, useState } from 'react';
import { Alert, Box, Typography } from '@mui/material';
import BuildCircleOutlined from '@mui/icons-material/BuildCircleOutlined';
import { apiFetch, buildApiUrl } from '../../../utils/apiClient';

const POLL_INTERVAL_MS = 10_000;

export default function DeploymentMaintenanceBanner() {
  const [maintenance, setMaintenance] = useState(false);

  useEffect(() => {
    let mounted = true;

    const checkStatus = async () => {
      try {
        const response = await apiFetch(buildApiUrl('/api/deployment-status'), {
          cache: 'no-store',
          timeout: 5_000,
        });
        if (!response.ok) return;
        const body: unknown = await response.json();
        if (
          mounted &&
          typeof body === 'object' &&
          body !== null &&
          'maintenance' in body &&
          typeof body.maintenance === 'boolean'
        ) {
          setMaintenance(body.maintenance);
        }
      } catch {
        // A transient deployment/network failure should not interrupt the app.
      }
    };

    void checkStatus();
    const intervalId = window.setInterval(() => {
      void checkStatus();
    }, POLL_INTERVAL_MS);

    return () => {
      mounted = false;
      window.clearInterval(intervalId);
    };
  }, []);

  if (!maintenance) return null;

  return (
    <Box sx={{ position: 'relative', zIndex: 1500 }}>
      <Alert
        severity="warning"
        icon={<BuildCircleOutlined />}
        sx={{
          borderRadius: 0,
          alignItems: 'center',
          '& .MuiAlert-message': { width: '100%' },
        }}
      >
        <Typography variant="body2">
          Service may be briefly interrupted while we perform routine site maintenance.
        </Typography>
      </Alert>
    </Box>
  );
}
